import { render, staticRenderFns } from "./exercise-content.vue?vue&type=template&id=4497edda&scoped=true"
import script from "./exercise-content.vue?vue&type=script&lang=js"
export * from "./exercise-content.vue?vue&type=script&lang=js"
import style0 from "./exercise-content.vue?vue&type=style&index=0&id=4497edda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4497edda",
  null
  
)

export default component.exports